<app-breadcrumb [crumbPaths]="[{
    name: 'Home',
    path: '/home'
}, {
    name: 'Surveys',
    path: '/conduct',
    active: true
}]"></app-breadcrumb>
<app-page-header title="Surveys" [buttons]="[{
        name: 'Add New',
        eventName: 'add',
        cssClass: 'bg-primary'
    }]" (onButtonClick)="action($event)">
</app-page-header>

<app-page-content>
    <app-data-grid [dataSource]="dataSource" [config]="config" [dataLength]="dataSource.length" [isLoading]="isLoading"
        (dataActionEvent)="action($event)">
    </app-data-grid>
</app-page-content>

<dx-popup [width]="300" [height]="280" [showTitle]="true" title="Conducting Survey" [dragEnabled]="false"
    [hideOnOutsideClick]="true" [showCloseButton]="false" [(visible)]="surveyClientSelectPopup">
    <div *dxTemplate="let data of 'content'">
        <div class="mb-2">
            Survey
            <dx-select-box [(value)]="selectedSurvey" [items]="surveyList" displayExpr="name" valueExpr="_id"></dx-select-box>
        </div>
        <div class="mb-2">
            Client
            <dx-select-box [(value)]="selectedClient" [items]="clientList" displayExpr="name" valueExpr="_id" ></dx-select-box>
        </div>
        <dx-button (onClick)="proceedToConduct()" class="w-100 bg-success">Proceed</dx-button>
    </div>
</dx-popup>

<app-alert [(visible)]="alertFormDuplicate.visible" [buttons]="[{
    name: 'Calcel',
    eventName: 'cancel',
    cssClass: 'bg-secondary'
}, {
    name: 'Yes, Proceed',
    eventName: 'okay',
    cssClass: 'bg-danger'
}]" (successHandler)="cloneConduct(alertFormDuplicate.selected);
">
Are you Sure?
</app-alert>